export const secondaryButtonStyle = (appTheme, hoveredButton, hoverKey) => ({
  padding: "10px 14px",
  borderRadius: "12px",
  border: appTheme.pillBorder,
  cursor: "pointer",
  background: hoveredButton === hoverKey ? appTheme.softBackground : appTheme.pillBackground,
  color: appTheme.primaryText,
  transform: hoveredButton === hoverKey ? "translateY(-1px)" : "none",
  transition: "all 0.15s ease",
  boxShadow:
    hoveredButton === hoverKey
      ? "0 8px 20px rgba(15, 23, 42, 0.08)"
      : "none"
});

export const primaryButtonStyle = (isValid, hoveredButton, hoverKey, appTheme) => ({
  padding: "10px 18px",
  borderRadius: "12px",
  border: "none",
  cursor: "pointer",
  background: isValid
    ? appTheme.accentColor
    : appTheme.softBackground,
  color: isValid ? "#ffffff" : appTheme.mutedText,
  transform:
    hoveredButton === hoverKey && isValid
      ? "translateY(-1px)"
      : "none",
  transition: "all 0.15s ease",
  boxShadow:
    hoveredButton === hoverKey && isValid
      ? "0 10px 24px rgba(37, 99, 235, 0.22)"
      : "none"
});

export const closeButtonStyle = (hoveredButton, hoverKey, appTheme) => ({
  width: "36px",
  height: "36px",
  borderRadius: "999px",
  border: appTheme.pillBorder,
  background: hoveredButton === hoverKey ? appTheme.softBackground : appTheme.cardBackground,
  cursor: "pointer",
  fontSize: "18px",
  lineHeight: 1,
  transition: "all 0.15s ease",
  transform: hoveredButton === hoverKey ? "scale(1.05)" : "scale(1)"
});